export default {"src":"/_next/static/media/check-icon.2f152e43.svg","height":17,"width":17,"blurWidth":0,"blurHeight":0};